import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes";

interface TimeSlotProps {
  time: string;
  selectedDate?: Date;
  duration?: number;
  disabled?: boolean;
}

const TimeSlot: React.FC<TimeSlotProps> = ({
  time,
  selectedDate,
  duration,
  disabled = false,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return;

    // Extract the start time from the displayed time range (e.g., "12:00 PM - 1:00 PM")
    const displayedStartTime = time.split(" - ")[0]; // Gets "12:00 PM"
    
    // Convert 12-hour format to 24-hour format
    const convertTo24Hour = (time12h: string): string => {
      const [time, modifier] = time12h.split(" ");
      let [hours, minutes] = time.split(":");
      
      if (hours === "12") {
        hours = "00";
      }
      
      if (modifier === "PM") {
        hours = (parseInt(hours, 10) + 12).toString();
      }
      
      return `${hours.padStart(2, "0")}:${minutes}`;
    };
    
    const startTime24h = convertTo24Hour(displayedStartTime);
     
     // Navigate to create session page with state
    navigate(ROUTES.CREATE_SESSION, {
      state: {
        selectedDate: selectedDate || new Date(),
        startTime: startTime24h, // Pass converted 24-hour format
        duration: duration,
      },
    });
  };

  return (
    <button
      className={`flex w-full ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      }`}
      onClick={handleClick}
      disabled={disabled}
      type="button"
    >
      <span className="checkbox-group-item w-full">{time}</span>
    </button>
  );
};

export default TimeSlot;
